import { Spinner } from '@Common/Spinner';
import { Crumbs } from 'commonTypes';
import { PreparationPage } from 'components/SubscriptionComponents';
import { ActiveSubscriptionPage } from 'components/SubscriptionComponents/RootPageModule/ActiveSubscriptionPage';
import { Layout } from 'pages/Layout/Layout';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useGetSubscription } from 'store/subscription/actions';

const crumbs: Crumbs[] = [{ name: 'Subscription', href: '/subscription', current: true }];

const Subscription = () => {
  const { data: subscription, isPending, isSuccess, refetch } = useGetSubscription();

  return (
    <Layout crumbs={crumbs}>
      <div
        className="max-w-screen min-w-screen bg-white p-4 rounded-lg relative overflow-auto scrollbar"
        style={{
          height: 'calc(100vh - 64px - 20px - 24px - 24px - 16px - 36px - 16px)',
        }}
      >
        {isPending ? (
          <div className="w-full flex items-center justify-center h-full bg-white">
            <Spinner color="bg-primary" />
          </div>
        ) : isSuccess ? (
          <>
            {subscription?.subscriptions.find(
              (sub) => sub.product_type.toLowerCase() === 'menu',
            )?.status === 'Preparation' && <PreparationPage />}
            {subscription?.subscriptions.find(
              (sub) => sub.product_type.toLowerCase() === 'menu',
            )?.status !== 'Preparation' && <ActiveSubscriptionPage />}
          </>
        ) : (
          <div className="w-full flex flex-col items-center justify-center h-full bg-white">
            <span className="text-xl font-semibold text-primary">
              <FormattedMessage id="subscriptionCreatingTitle" />
            </span>
            <div className="mt-3 text-lg">
              <FormattedMessage id="subscriptionCreatingText" />
            </div>
            <button
              onClick={() => refetch()}
              className="mt-3 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm md:hover:bg-indigo-700 md:focus:outline-none md:focus:ring-2 md:focus:ring-indigo-500 md:focus:ring-offset-2"
            >
              <FormattedMessage id="reload" />
            </button>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default memo(Subscription);
